// extracted by mini-css-extract-plugin
module.exports = {"sectionBanner":"Banner_sectionBanner__3dTJW","medium":"Banner_medium__2ymYY","large":"Banner_large__1ukwr","rounded":"Banner_rounded__25ioV"};